import React from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import PaperReference from '../components/PaperReference';
import SEO from '../components/SEO';
import type { Paper } from '../types';

export const pageQuery = graphql`
  query ProjectBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        key
        title
        subtitle
        description
        papers {
          key
          title
          authors
          publication
          link
        }
        date(formatString: "YYYY")
        endDate(formatString: "YYYY")
        screenshot {
          childImageSharp {
            gatsbyImageData(width: 970, placeholder: BLURRED, layout: CONSTRAINED)
          }
        }
      }
    }
  }
`;

export type ProjectPageProps = {
  data: Queries.ProjectBySlugQuery;
};

export default function ProjectPage({ data }: ProjectPageProps) {
  const post = data.markdownRemark;

  if (!post || !post.frontmatter) return null;

  const { frontmatter, html } = post;
  const { title, subtitle, date, endDate, papers, screenshot } = frontmatter;

  return (
    <div className="content project-page">
      <div className="project-top-bar">
        <div className="container">
          <div className="row">
            <div className="span10 offset1 center">
              <div className="project-controls">
                <a className="back-link" href="/projects">
                  <span className="arrow">&uarr;</span>
                  <span className="link">back to all projects</span>
                  <span className="arrow">&uarr;</span>
                </a>
              </div>
            </div>
            <div className="span6 right">
              {/* <!-- .project-controls -->
          <!-- %a(href="#") -->
          <!-- previous -->
          <!-- .project-controls -->
          <!-- %a(href="#") -->
          <!-- next --> */}
            </div>
          </div>
        </div>
      </div>
      <div className="content-row odd project-detail">
        <div className="container">
          <div className="row">
            <div className="span10 offset1 center">
              <h1 className="project-title">
                {title} ({date}
                {endDate && endDate !== date ? `-${endDate}` : ''})
              </h1>
              <h4>{subtitle}</h4>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="span10 offset1">
              <div className="project-image">
                {screenshot?.childImageSharp?.gatsbyImageData && (
                  <GatsbyImage alt="Project screenshot" image={screenshot?.childImageSharp?.gatsbyImageData} />
                )}
              </div>
            </div>
          </div>
        </div>
        {html && (
          <div className="container">
            <div className="row">
              <div className="span10 offset1" dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          </div>
        )}
        {papers && papers.length > 0 && (
          <div className="container">
            <div className="row">
              <div className="span10 offset1">
                <h2>Publications</h2>
                <ul>
                  {papers.map(
                    (paper) =>
                      paper && (
                        <li key={paper?.key}>
                          <PaperReference paper={paper as Paper} />
                        </li>
                      )
                  )}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export const Head = ({ data }: ProjectPageProps) => {
  const title = data.markdownRemark?.frontmatter?.title;

  return <SEO title={`Projects | ${title}`} />;
};
